import React from 'react';

const GoogleLoginButton = () => {

    const handleSignInClick = () => {
        window.location.href = 'https://backend-wpxi.onrender.com/oauth2/authorization/google';
    };

    return (
        <div className="navbar-form-group relative mb-3 h-8 rounded bg-orange-600/90 text-center text-white text-[14px] font-light">
            <button
                className="google w-full h-full rounded cursor-pointer"
                onClick={handleSignInClick}
            >
               Login Google
            </button>
        </div>
    );
};

export default GoogleLoginButton;